// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1jr26","label":"LabeledBox_label__3n6Yk"};